import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import LandingPage from "@/components/landing/LandingPage";
import WhitepaperPage from "@/components/docs/WhitepaperPage";
import OverviewPage from "@/components/docs/OverviewPage";
import LearnPage from "@/components/docs/LearnPage";
import TermsPage from "@/components/legal/TermsPage";
import PrivacyPage from "@/components/legal/PrivacyPage";
import RiskPage from "@/components/legal/RiskPage";
import CookiePage from "@/components/legal/CookiePage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/docs/whitepaper" element={<WhitepaperPage />} />
        <Route path="/docs/overview" element={<OverviewPage />} />
        <Route path="/docs/learn" element={<LearnPage />} />
        <Route path="/legal/terms" element={<TermsPage />} />
        <Route path="/legal/privacy" element={<PrivacyPage />} />
        <Route path="/legal/risk" element={<RiskPage />} />
        <Route path="/legal/cookies" element={<CookiePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
